import type { InformationDomainId, MenuPlacement } from './information-boundaries';
import type { Persona } from './model';

export type WorkspaceInformationPlacement = Readonly<{
  placement: MenuPlacement;
  label: string;
}>;

/** Compact runtime projection; the full policy ledger remains available from the package root. */
export function workspaceInformationPlacement(
  persona: Persona,
  domain: InformationDomainId,
): WorkspaceInformationPlacement | null {
  // The enterprise master uses the same shared information domains as HQ,
  // while each write still goes through its server-side authority check.
  const contractor = persona === 'contractor_manager' || persona === 'contractor_worker';
  if (domain === 'central-approval' || domain === 'statutory-records')
    return persona === 'contractor_worker'
      ? null
      : {
          placement: 'standalone',
          label: domain === 'central-approval' ? '전자결재' : '법정의무',
        };
  if (domain === 'shared-resources')
    return {
      placement: persona === 'contractor_worker' ? 'contextual-only' : 'secondary',
      label: '안전보건자료실',
    };
  if (domain === 'controlled-documents')
    return {
      placement: contractor
        ? 'contextual-only'
        : persona.startsWith('hq_')
          ? 'secondary'
          : 'standalone',
      label: '안전보건자료실',
    };
  return {
    placement: contractor ? 'contextual-only' : 'secondary',
    label: contractor
      ? persona === 'contractor_manager'
        ? '배정 설비·MSDS'
        : '작업 설비·MSDS'
      : '화학물질·설비',
  };
}
